import { useState } from 'react';

const WHATSAPP_NUMBER = '551143453116';
const WHATSAPP_MESSAGE = 'Olá! Gostaria de falar com um especialista em TI.';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="fixed bottom-7 right-7 z-50 flex items-center gap-3">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-3 pointer-events-none'
        }`}
      >
        <div className="bg-brand-surface border border-brand-border text-white text-sm font-medium px-4 py-2 rounded-lg whitespace-nowrap">
          Fale conosco agora!
          <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-brand-surface border-t border-r border-brand-border rotate-45" />
        </div>
      </div>

      {/* Button */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Fale conosco pelo WhatsApp"
        className="relative w-14 h-14 flex items-center justify-center rounded-full cursor-pointer transition-transform duration-200 hover:scale-110"
        style={{ background: '#25D366' }}
      >
        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full animate-ping opacity-25" style={{ background: '#25D366' }} />
        <span className="absolute inset-[-4px] rounded-full opacity-15 animate-pulse" style={{ background: '#25D366' }} />

        {/* Icon */}
        <i className="ri-whatsapp-line text-white text-2xl relative z-10" />
      </button>
    </div>
  );
}
